// Myanmar phone normalisation to E.164. Mobiles: +959 followed by 7–9 digits.
import { toAsciiDigits } from './digits';

const E164 = /^\+[1-9][0-9]{6,14}$/;

export function normalizePhone(raw: string): string | null {
  let s = toAsciiDigits(raw).replace(/[\s\-().]/g, '');
  if (s.startsWith('00')) s = '+' + s.slice(2);
  if (s.startsWith('+')) return E164.test(s) ? s : null;
  if (s.startsWith('959')) s = '+' + s;
  else if (s.startsWith('09')) s = '+95' + s.slice(1);
  else if (s.startsWith('9') && s.length >= 8 && s.length <= 10) s = '+95' + s;
  else if (s.startsWith('95')) s = '+' + s;
  else return null;
  return E164.test(s) ? s : null;
}

/** +959791234567 → 09 791 234 567 for display */
export function formatPhoneLocal(e164: string): string {
  if (!e164.startsWith('+95')) return e164;
  const local = '0' + e164.slice(3);
  return local.replace(/^(\d{2})(\d{3})(\d{3})(\d+)$/, '$1 $2 $3 $4');
}
